import styled from 'styled-components';

import logo from '../../../static/image/logo-footer.svg';
import theme from '../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex: 1;
  height: 300px;
  justify-content: center;
  align-items: center;
  background-color: ${theme.background};
`;

export const Logo = styled.img.attrs({
  src: logo,
})`
  width: 280px;
`;
